<template>
  <Head title="Two-factor Confirmation" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-gray-700">
    <div class="w-full max-w-md">
      <logo class="flex items-center justify-center text-3xl" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <div class="mb-4 text-sm text-gray-600">
            <template v-if="! recovery">
              Please confirm access to your account by entering the authentication code provided by your authenticator application.
            </template>

            <template v-else>
              Please confirm access to your account by entering one of your emergency recovery codes.
            </template>
          </div>
          <div v-if="! recovery">
            <text-input ref="codeInput" v-model="form.code" :error="form.errors.code" inputmode="numeric" autocomplete="one-time-code" class="mt-10" label="Code" type="text" autofocus autocapitalize="off" />
          </div>
          <div v-else>
            <text-input ref="recoveryCodeInput" v-model="form.recovery_code" :error="form.errors.recovery_code" autocomplete="one-time-code" class="mt-10" label="Code" type="text" autofocus autocapitalize="off" />
          </div>
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <button type="button" class="text-sm text-gray-600 hover:text-gray-900 underline cursor-pointer" @click.prevent="toggleRecovery">
            <template v-if="! recovery">
              Use a recovery code
            </template>

            <template v-else>
              Use an authentication code
            </template>
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Login</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { nextTick } from 'vue'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      recovery: false,
      form: this.$inertia.form({
        code: '',
        recovery_code: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/two-factor-challenge', {
        onSuccess: (page) => {
          if (page.props.auth.user) {
            this.$root.$i18n.locale = page.props.auth.user.language
          }
        },
      })
    },
    async toggleRecovery(){
      this.recovery ^= true

      await nextTick()

      if (this.recovery) {
        //recoveryCodeInput.value.focus()
        this.form.code = ''
      } else {
        //codeInput.value.focus()
        this.form.recovery_code = ''
      }
    },
  },
}
</script>
